if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(this.openedBy.getAttribute('data-media-id'));
        this.setupNavigation();
        this.setupKeyboardNav();
        this.setupSwipeNav();
        this.setupThumbnailNav();
        this.dispatchEvent(new CustomEvent('productModalShown'));
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__item[data-media-id]'));
      }

      showActiveMedia(mediaId) {
        if (!mediaId) return;
        const items = this.getMediaItems();
        items.forEach((el) => {
          el.classList.toggle('active', el.getAttribute('data-media-id') === mediaId);
        });
        this.querySelectorAll('.product-media-modal__thumbnail').forEach((btn) => {
          const isActive = btn.getAttribute('data-media-id') === mediaId;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', isActive);
        });
        const activeMedia = this.querySelector('.product-media-modal__item[data-media-id="' + mediaId + '"]');
        if (!activeMedia) return;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.offsetWidth) {
          container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
        }

        const deferredMedia = activeMedia.querySelector('deferred-media');
        if (deferredMedia) {
          const template = deferredMedia.querySelector('template');
          const hasYoutube = template && template.content && template.content.querySelector('.js-youtube');
          if (hasYoutube && deferredMedia.loadContent) deferredMedia.loadContent();
        }
      }

      setupNavigation() {
        const prevBtn = this.querySelector('[data-modal-nav="prev"]');
        const nextBtn = this.querySelector('[data-modal-nav="next"]');
        if (!prevBtn || !nextBtn) return;

        prevBtn.onclick = () => this.navigate('prev');
        nextBtn.onclick = () => this.navigate('next');
      }

      navigate(direction) {
        const items = this.getMediaItems();
        if (items.length === 0) return;
        const activeEl = this.querySelector('.product-media-modal__item.active');
        const currentIndex = activeEl ? items.indexOf(activeEl) : 0;
        let nextIndex;
        if (direction === 'prev') {
          nextIndex = currentIndex <= 0 ? items.length - 1 : currentIndex - 1;
        } else {
          nextIndex = currentIndex >= items.length - 1 ? 0 : currentIndex + 1;
        }
        const nextMediaId = items[nextIndex].getAttribute('data-media-id');
        this.showActiveMedia(nextMediaId);
        this.dispatchEvent(new CustomEvent('productModalShown'));
        this.dispatchEvent(new CustomEvent('lightboxMediaChange', { detail: { mediaId: nextMediaId } }));
      }

      setupKeyboardNav() {
        if (this._keyNavSetup) return;
        this._keyNavSetup = true;
        this.addEventListener('keydown', (e) => {
          if (e.code === 'ArrowLeft') {
            e.preventDefault();
            this.navigate('prev');
          } else if (e.code === 'ArrowRight') {
            e.preventDefault();
            this.navigate('next');
          }
        });
      }

      setupSwipeNav() {
        if (this._swipeSetup) return;
        this._swipeSetup = true;
        const SWIPE_THRESHOLD = 50;
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        let startX = 0;
        let startY = 0;

        container.addEventListener('touchstart', (e) => {
          if (e.touches.length === 1) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          }
        }, { passive: true });

        container.addEventListener('touchend', (e) => {
          if (e.changedTouches.length !== 1) return;
          const deltaX = e.changedTouches[0].clientX - startX;
          const deltaY = e.changedTouches[0].clientY - startY;
          if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
          if (Math.abs(deltaY) > Math.abs(deltaX)) return;
          if (deltaX > 0) {
            this.navigate('prev');
          } else {
            this.navigate('next');
          }
        }, { passive: true });
      }

      setupThumbnailNav() {
        if (this._thumbNavSetup) return;
        this._thumbNavSetup = true;
        this.querySelectorAll('.product-media-modal__thumbnail').forEach((btn) => {
          btn.addEventListener('click', () => {
            const mediaId = btn.getAttribute('data-media-id');
            if (mediaId) {
              this.showActiveMedia(mediaId);
              this.dispatchEvent(new CustomEvent('productModalShown'));
              this.dispatchEvent(new CustomEvent('lightboxMediaChange', { detail: { mediaId } }));
            }
          });
        });
      }
    }
  );
}
